import { useServiceWorkerUpdate } from "../lib/swUpdate";

/**
 * Fixed toast at the bottom of the screen when a new version is ready.
 *
 * Sits outside the router so it survives route changes. The participant taps "Update now" and the page reloads with
 * the new code. Nothing is lost: forms save as they go, and offline drafts sit in IndexedDB.
 */
export function UpdatePrompt() {
  const { updateAvailable, applyUpdate } = useServiceWorkerUpdate();

  if (!updateAvailable) return null;

  return (
    <div className="fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom)+16px)] z-50 flex justify-center px-5 print:hidden">
      <div className="flex w-full max-w-[420px] items-center justify-between gap-3 rounded-[var(--radius-card)] border border-border bg-surface p-3.5 shadow-lg">
        <span className="text-[13px] text-text">A new version is available</span>
        <button
          type="button"
          onClick={applyUpdate}
          className="shrink-0 rounded-[var(--radius-control)] bg-accent px-4 py-2 text-[13px] font-bold text-on-accent active:bg-accent-pressed"
        >
          Update now
        </button>
      </div>
    </div>
  );
}
